"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Widget = exports.WidgetConfig = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class WidgetConfig {
    autoHide;
    isInteractive;
    position;
    widthPercent;
    url;
}
exports.WidgetConfig = WidgetConfig;
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], WidgetConfig.prototype, "autoHide", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(({ value }) => value === "true" || value === true),
    __metadata("design:type", Boolean)
], WidgetConfig.prototype, "isInteractive", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], WidgetConfig.prototype, "position", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Transform)(({ value }) => Number(value)),
    __metadata("design:type", Number)
], WidgetConfig.prototype, "widthPercent", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], WidgetConfig.prototype, "url", void 0);
class Widget {
    kind;
    config;
}
exports.Widget = Widget;
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], Widget.prototype, "kind", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => WidgetConfig),
    __metadata("design:type", WidgetConfig)
], Widget.prototype, "config", void 0);
